import { render, staticRenderFns } from "./singin.vue?vue&type=template&id=ba87a1f2&scoped=true&"
import script from "./singin.vue?vue&type=script&lang=js&"
export * from "./singin.vue?vue&type=script&lang=js&"
import style0 from "./singin.vue?vue&type=style&index=0&id=ba87a1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba87a1f2",
  null
  
)

export default component.exports